
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".67","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 16h8M12 20h8","stroke":"#56BFC7"}}),_c('path',{attrs:{"d":"M7 5h18a1 1 0 011 1v19a3 3 0 01-3 3H9a3 3 0 01-3-3V6a1 1 0 011-1v0zM10 3v4M16 3v4M22 3v4","stroke":"#fff"}})])])
          )
        }
      }
    